import { Text, View } from "react-native";

export function InfoRow({
  label,
  value,
}: {
  label: string;
  value: string;
}) {
  return (
    <View className="mt-2 rounded-lg border border-gray-200 bg-gray-50 p-4">
      <Text className="text-lg font-bold">{label}</Text>
      <Text>{value}</Text>
    </View>
  );
}
